var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissingScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00008 0.666672C13.6025 0.666672 17.3334 4.39763 17.3334 9.00001C17.3334 13.6024 13.6025 17.3333 9.00008 17.3333C4.39771 17.3333 0.666748 13.6024 0.666748 9.00001C0.666748 4.39763 4.39771 0.666672 9.00008 0.666672ZM5.07779 5.07771C5.37856 4.77694 5.85045 4.75381 6.17755 5.00831L6.25612 5.07771L9.00029 7.82188L11.7445 5.07771C12.0703 4.75188 12.597 4.75188 12.9228 5.07771C13.2236 5.37848 13.2467 5.85038 12.9922 6.17747L12.9228 6.25605L10.1786 9.00021L12.9228 11.7444C13.2486 12.0702 13.2486 12.5969 12.9228 12.9227C12.7603 13.0852 12.547 13.1669 12.3336 13.1669C12.1558 13.1669 11.9781 13.1102 11.8297 12.9972L11.7445 12.9227L9.00029 10.1785L6.25612 12.9227C6.09362 13.0852 5.88029 13.1669 5.66696 13.1669C5.45362 13.1669 5.24029 13.0852 5.07779 12.9227C4.77702 12.6219 4.75388 12.1501 5.00838 11.823L5.07779 11.7444L7.82196 9.00021L5.07779 6.25605C4.75196 5.93021 4.75196 5.40355 5.07779 5.07771Z",
    fill: "#999DA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingScanIcon);
export default __webpack_public_path__ + "static/media/missingScanIcon.b9cb3dbf.svg";
export { ForwardRef as ReactComponent };